/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const jaRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: '学校の追加のリクエスト',
    description: '下記のフォームに入力してください。リクエストされた学校の追加は保証されてはいませんが、全てのリクエストはSheerIDによって調査、検討されます。',
    noCountry: '学校の所在国が確認できませんか？このオファーを受ける資格がありません',
    searchByOrgName: '学校が確認できませんか？名前で検索',
    completeRequest: '対象の学校または非対象の学校のリストで、学校が確認できませんか？リクエストを完了する',
    submit: '提出する',
    eligibleOrgs: '対象の学校。アイコンをクリックし、名前をコピーし、確認フォームに戻ります',
    ineligibleOrgs: '非対象の学校。申し訳ございませんが、これらの学校の学生はこのオファーの対象ではありません',
    none: '何もない',
    country: 'どこの学校に通っていますか？',
    changeLanguage: '言語を変えてください',
    copied: 'コピー済み',
    firstName: 'ファーストネーム',
    lastName: '苗字',
    emailAddress: '電子メールアドレス',
    poweredBy: 'SheerIDによる検証サービス',
    fields: {
        countryPlaceholder: '国を選択してください',
        domainLabel: '学校のウェブサイト',
        domainPlaceholder: 'www.watashino_daigaku.jp  ',
        orgNameLabel: '学校名',
        orgNamePlaceholder: '私の学校',
    },
    step: {
        success: {
            title: 'お申し込みありがとうございます',
            description: '教育機関の追加リクエストを承りました。 調査期間として回答までに最長 7 日間ほどお待ちいただく場合がございます。また、リクエストいただいた教育機関が、オートデスク教育機関限定ライセンスの認定教育機関として承認される保証はございませんので、ご了承ください。また、ご利用可能なその他のサブスクリプション オプションについてもご確認ください。',
        },
        error: {
            title: '予期せぬエラーが起きました',
            description: '申し訳ございませんが、あなたのリクエストにお応えすることができません。しばらくしてから、もう一度やり直してください。',
            seeingProblem: 'このエラーが続く場合は',
            contactUs: 'ご連絡ください',
        },
    },
    errorId: {
        invalidCountry: 'このフィールドは必須です',
        invalidEmail: '無効なEメールアドレスです',
        invalidFirstName: '無効なファーストネームです',
        invalidLastName: '無効なラストネームです',
        requiredField: 'このフィールドは必須です',
        invalidField: 'このフィールドは無効です',
        invalidUrl: '無効なURLです',
        tooManyResults: '検索結果の数が多すぎます。検索を見直し、もう一度、試してください',
    },
    faq: 'SheerIDによる学校の依頼書追加に関するFAQ',
    countries: {
        AD: 'アンドラ公国',
        AE: 'アラブ首長国連邦',
        AF: 'アフガニスタン',
        AG: 'アンティグア・バーブーダ',
        AI: 'アンギラ',
        AL: 'アルバニア語',
        AM: 'アルメニア語',
        AN: 'オランダ領アンティル',
        AO: 'アンゴラ',
        AR: 'アルゼンチン',
        AS: 'アメリカ領サモア',
        AT: 'オーストリア',
        AU: 'オーストラリア',
        AW: 'アルバ',
        AZ: 'アゼルバイジャン語',
        BA: 'ボスニアヘルツェゴビナ',
        BB: 'バルバドス',
        BD: 'バングラデシュ',
        BE: 'ベルギー',
        BF: 'ブルキナファソ',
        BG: 'ブルガリア語',
        BH: 'バーレーン',
        BI: 'ブルンジ',
        BJ: 'ベナン',
        BM: 'バミューダ',
        BN: 'ブルネイ・ダルサラーム',
        BO: 'ボリビア',
        BR: 'ブラジル',
        BS: 'バハマ',
        BT: 'ブータン',
        BV: 'ブーベ島',
        BW: 'ボツワナ',
        BY: 'ベラルーシ語',
        BZ: 'ベリーズ',
        CA: 'カナダ',
        CD: 'コンゴ民主共和国',
        CF: '中央アフリカ共和国',
        CG: 'コンゴ共和国',
        CH: 'スイス',
        CI: 'コートジボワール（コートジボワール）',
        CK: 'クック諸島',
        CL: 'チリ',
        CM: 'カメルーン共和国',
        CN: '中国',
        CO: 'コロンビア',
        CR: 'コスタリカ',
        CU: 'キューバ共和国',
        CV: 'カーボベルデ',
        CY: 'キプロス',
        CZ: 'チェコ共和国',
        DE: 'ドイツ',
        DJ: 'ジブチ',
        DK: 'デンマーク',
        DM: 'ドミニカ国',
        DO: 'ドミニカ共和国',
        DZ: 'アルジェリア',
        EC: 'エクアドル',
        EE: 'エストニア',
        EG: 'エジプト',
        EH: '西サハラ',
        ER: 'エリトリア',
        ES: 'スペイン',
        ET: 'エチオピア',
        FI: 'フィンランド',
        FJ: 'フィジー',
        FK: 'フォークランド諸島',
        FM: 'ミクロネシア',
        FO: 'フェロー諸島',
        FR: 'フランス',
        GA: 'ガボン',
        GB: 'イギリス',
        GD: 'グレナダ',
        GE: 'ジョージア',
        GF: 'フランス領ガイアナ',
        GH: 'ガーナ',
        GI: 'ジブラルタル',
        GL: 'グリーンランド',
        GM: 'ガンビア',
        GN: 'ギニア',
        GP: 'グアドループ（フランス語）',
        GQ: '赤道ギニア',
        GR: 'ギリシャ',
        GS: 'サウスジョージア・サウスサンドイッチ諸島',
        GT: 'グアテマラ',
        GU: 'グアム（米国）',
        GW: 'ギニアビサウ',
        GY: 'ガイアナ',
        HK: '香港',
        HM: 'ハード島とマクドナルド諸島',
        HN: 'ホンジュラス',
        HR: 'クロアチア',
        HT: 'ハイチ',
        HU: 'ハンガリー',
        ID: 'インドネシア',
        IE: 'アイルランド',
        IL: 'イスラエル',
        IN: 'インド',
        IO: 'イギリス領インド洋地域',
        IQ: 'イラク',
        IR: 'イラン',
        IS: 'アイスランド',
        IT: 'イタリア',
        JM: 'ジャマイカ',
        JO: 'ヨルダン',
        JP: '日本',
        KE: 'ケニア',
        KG: 'キルギスタン',
        KH: 'カンボジア',
        KI: 'キリバス',
        KM: 'コモロ',
        KN: 'セントクリストファー・ネイビス・アンギラ',
        KP: '北朝鮮',
        KR: '韓国',
        KW: 'クウェート',
        KY: 'ケイマン諸島',
        KZ: 'カザフスタン',
        LA: 'ラオス',
        LB: 'レバノン',
        LC: 'セントルシア',
        LI: 'リヒテンシュタイン',
        LK: 'スリランカ',
        LR: 'リベリア',
        LS: 'レソト',
        LT: 'リトアニア',
        LU: 'ルクセンブルク',
        LV: 'ラトビア',
        LY: 'リビア',
        MA: 'モロッコ',
        MC: 'モナコ',
        MD: 'モルダビア',
        ME: 'モンテネグロ',
        MG: 'マダガスカル',
        MH: 'マーシャル諸島',
        MK: 'マケドニア',
        ML: 'マリ',
        MM: 'ミャンマー',
        MN: 'モンゴル',
        MO: 'マカオ',
        MP: '北マリアナ諸島',
        MQ: 'マルティニーク（フランス語）',
        MR: 'モーリタニア',
        MS: 'モントセラト',
        MT: 'マルタ',
        MU: 'モーリシャス',
        MV: 'モルディブ',
        MW: 'マラウイ',
        MX: 'メキシコ',
        MY: 'マレーシア',
        MZ: 'モザンビーク',
        NA: 'ナミビア',
        NC: 'ニューカレドニア（フランス語）',
        NE: 'ニジェール',
        NF: 'ノーフォーク島',
        NG: 'ナイジェリア',
        NI: 'ニカラグア',
        NL: 'オランダ',
        NO: 'ノルウェー',
        NP: 'ネパール',
        NR: 'ナウル',
        NU: 'ニウエ',
        NZ: 'ニュージーランド',
        OM: 'オマーン',
        PA: 'パナマ',
        PE: 'ペルー',
        PF: 'ポリネシア（フランス語）',
        PG: 'パプアニューギニア',
        PH: 'フィリピン',
        PK: 'パキスタン',
        PL: 'ポーランド',
        PM: 'サンピエール・ミクロン',
        PN: 'ピトケアン島',
        PR: 'プエルトリコ',
        PS: 'パレスチナ',
        PT: 'ポルトガル',
        PW: 'パラオ',
        PY: 'パラグアイ',
        QA: 'カタール',
        RE: 'レユニオン（フランス語）',
        RO: 'ルーマニア',
        RS: 'セルビア',
        RU: 'ロシア連邦',
        RW: 'ルワンダ',
        SA: 'サウジアラビア',
        SB: 'ソロモン諸島',
        SC: 'セイシェル',
        SD: 'スーダン',
        SE: 'スウェーデン',
        SG: 'シンガポール',
        SH: 'セントヘレナ',
        SI: 'スロベニア',
        SK: 'スロバキア共和国',
        SL: 'シエラレオネ',
        SM: 'サンマリノ',
        SN: 'セネガル',
        SO: 'ソマリア',
        SR: 'スリナム',
        SS: '南スーダン',
        ST: 'サントメ（サントメ）とプリンシペ',
        SV: 'エルサルバドル',
        SY: 'シリア',
        SZ: 'スワジランド',
        TC: 'タークス・カイコス諸島',
        TD: 'チャド',
        TF: 'フランス南部領',
        TG: 'トーゴ',
        TH: 'タイ王国',
        TJ: 'タジキスタン',
        TK: 'トケラウ',
        TL: '東ティモール',
        TM: 'トルクメニスタン',
        TN: 'チュニジア',
        TO: 'トンガ',
        TR: 'トルコ',
        TT: 'トリニダード・トバゴ',
        TV: 'ツバル',
        TW: '台湾',
        TZ: 'タンザニア',
        UA: 'ウクライナ',
        UG: 'ウガンダ',
        UM: '合衆国領有小離島 ',
        US: 'アメリカ',
        UY: 'ウルグアイ',
        UZ: 'ウズベキスタン',
        VA: 'バチカン市国',
        VC: 'セントビンセント・グレナディーン',
        VE: 'ベネズエラ',
        VG: 'バージン諸島（イギリス）',
        VI: 'バージン諸島（米国）',
        VN: 'ベトナム',
        VU: 'バヌアツ',
        WF: 'ウォリスフツナ諸島',
        WS: 'サモア',
        XK: 'コソボ',
        YE: 'イエメン',
        YT: 'マヨット',
        ZA: '南アフリカ',
        ZM: 'ザンビア',
        ZW: 'ジンバブエ',
    },
    locales: {
        ar: 'アラビア語',
        bg: 'ブルガリア語',
        cs: 'チェコ語',
        da: 'デンマーク語',
        de: 'ドイツ語',
        el: 'ギリシャ語',
        'en-GB': '英語（英国）',
        'en-US': '英語',
        'es-ES': 'スペイン語（スペイン）',
        es: 'スペイン語',
        fi: 'フィンランド語',
        'fr-CA': 'フランス語（カナダ）',
        fr: 'フランス語',
        hr: 'クロアチア語',
        hu: 'ハンガリー語',
        id: 'インドネシア語',
        is: 'アイスランド語',
        it: 'イタリア語',
        iw: 'ヘブライ語',
        ja: '日本語',
        ko: '韓国語',
        lt: 'リトアニア語',
        ms: 'マレー語',
        nl: 'オランダ語',
        no: 'ノルウェー語',
        pl: 'ポーランド語',
        'pt-BR': 'ポルトガル語（ブラジル）',
        pt: 'ポルトガル語',
        ro: 'ルーマニア語',
        ru: 'ロシア語',
        sk: 'スロバキア語',
        sl: 'スロベニア語',
        sr: 'セルビア語',
        sv: 'スウェーデン語',
        tr: 'トルコ語',
        'zh-HK': '中国語（香港）',
        zh: '中国語（繁体字）',
    },
};
